import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.less';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/images/logo.png" alt="SG Interior Design" className="logo-image" />
            </div>
            <p className="footer-description">{t('footer.description')}</p>
          </div>

          <div className="footer-section">
            <h4>{t('footer.quickLinks')}</h4>
            <nav className="footer-nav">
              <Link to="/">{t('nav.home')}</Link>
              <Link to="/about">{t('nav.about')}</Link>
              <Link to="/services">{t('nav.services')}</Link>
              <Link to="/projects">{t('nav.projects')}</Link>
              <Link to="/contact">{t('nav.contact')}</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4>{t('contact.info.title')}</h4>
            <div className="footer-contact">
              <p>
                <i className="fas fa-envelope"></i>
                <a href="mailto:stefani.georgieva@interior-sg.com">stefani.georgieva@interior-sg.com</a>
              </p>
              <p>
                <i className="fas fa-phone"></i>
                <a href="tel:+359886275939">+359 88 627 5939</a>
              </p>
              <p>
                <i className="fas fa-map-marker-alt"></i>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=ул.+Стара+Планина+34+Севлиево+България"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('contact.info.addressValue')}
                </a>
              </p>
              <p>
                <i className="fas fa-clock"></i>
                <span>{t('contact.info.workingHoursValue')}</span>
              </p>
              {/* <p className="holiday-hours">
                <i className="fas fa-tree"></i>
                <span>{t('contact.info.holidayHoursValue')}</span>
              </p> */}
            </div>
          </div>

          <div className="footer-section">
            <h4>{t('footer.followUs')}</h4>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/profile.php?id=61571604931438"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('contact.social.facebook')}
                className="social-icon"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/studio.sginterior"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('contact.social.instagram')}
                className="social-icon"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.tiktok.com/@sg.interior_design.bg"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('contact.social.tiktok')}
                className="social-icon"
              >
                <i className="fab fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} SG Interior Design. {t('footer.rights')}
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy">{t('cookies.banner.privacyPolicy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
